import { render, staticRenderFns } from "./SamplePage.vue?vue&type=template&id=6b27299a&scoped=true&"
import script from "./SamplePage.vue?vue&type=script&lang=js&"
export * from "./SamplePage.vue?vue&type=script&lang=js&"
import style0 from "./SamplePage.vue?vue&type=style&index=0&id=6b27299a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27299a",
  null
  
)

export default component.exports